import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { delay, map } from 'rxjs';

import {
    seSideKeyImagesComponentSetImagesPerRowInPlaceholder,
    seSideKeyImagesComponentSetKeyImagesData,
} from '../se-side/se-side-components/se-side-key-images-container/redux/se-side-key-images-container.actions';
import { seSidePatientHistoryComponentSetPatient } from '../se-side/se-side-components/se-side-patient-history/redux/se-side-patient-history.actions';
import {
    seReportNullAction,
    seReportSaveCompleted,
    seReportSetImagesPerRowInPlaceholder,
    seReportSetIsModified,
    seReportSetKeyImages,
    seReportSetPatientId,
} from './report.actions';

@Injectable()
export class ReportEffects {
    constructor(private actions$: Actions) {}

    saveCompleted$ = createEffect(() =>
        this.actions$.pipe(
            ofType(seReportSaveCompleted),
            map(({ error }) => {
                if (error) {
                    return seReportNullAction();
                }
                return seReportSetIsModified({ isModified: false });
            }),
        ),
    );

    setPatientId$ = createEffect(() =>
        this.actions$.pipe(
            ofType(seReportSetPatientId),
            // TODO: Da modificare se-side-patient-history.component invece che qua.
            delay(100),
            map(({ patientId }) =>
                seSidePatientHistoryComponentSetPatient({
                    formType: 'report',
                    patientId: patientId || '',
                }),
            ),
        ),
    );

    setKeyImages$ = createEffect(() =>
        this.actions$.pipe(
            ofType(seReportSetKeyImages),
            map(({ keyImages }) =>
                seSideKeyImagesComponentSetKeyImagesData({
                    formType: 'visit',
                    keyImages,
                }),
            ),
        ),
    );

    setImagesForRowInPlaceholder$ = createEffect(() =>
        this.actions$.pipe(
            ofType(seReportSetImagesPerRowInPlaceholder),
            map(({ imagesPerRowInPlaceholder }) =>
                seSideKeyImagesComponentSetImagesPerRowInPlaceholder({
                    formType: 'visit',
                    imagesPerRowInPlaceholder,
                }),
            ),
        ),
    );
}
